var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

function parallel(_x) {
  return _parallel.apply(this, arguments);
}

function _parallel() {
  _parallel = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(promises) {
    var results, keys;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all(Object.values(promises).map(function (func) {
              return func();
            }));

          case 2:
            results = _context.sent;

            if (!Array.isArray(promises)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", results);

          case 5:
            // If the initial structure was an object, rebuild an object with the results
            keys = Object.keys(promises);
            return _context.abrupt("return", results.reduce(function (object, resultPart, index) {
              object[keys[index]] = resultPart;
              return object;
            }, {}));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _parallel.apply(this, arguments);
}

module.exports = {
  parallel: parallel
};